<script>
import webservice from '@/utils/webservice'
export default {
  name: 'ReserveCarComponent',
  data () {
    return {
      loading: false,
      carCode: null,
      sourceId: null,
      removeReserve: false
    }
  },
  methods: {
    onPressBtnReserveConfirm () {
      let requestLocalTime = new Date().getTime()
      this.loading = true
      webservice.publications.reserve(this.carCode, this.sourceId).then(response => {
        console.log(`response: ${JSON.stringify(response)}`)
        let responseLocalTime = new Date().getTime()
        let diffTime = responseLocalTime - requestLocalTime
        if (diffTime < 2000) {
          setTimeout((self) => {
            self.loading = false
            self.$emit('onCreatedCarReserve', response)
            self.close()
          }, 2000 - diffTime, this)
        } else {
          this.loading = false
          this.$emit('onCreatedCarReserve', response)
          this.close()
        }
      })
    },
    onPressBtnRemoveReserveConfirm () {
      let requestLocalTime = new Date().getTime()
      this.loading = true
      webservice.publications.removeReserve(this.carCode, this.sourceId).then(response => {
        console.log(`response: ${JSON.stringify(response)}`)
        let responseLocalTime = new Date().getTime()
        let diffTime = responseLocalTime - requestLocalTime
        if (diffTime < 2000) {
          setTimeout((self) => {
            self.loading = false
            self.$emit('onRemovedCarReserve', response)
            self.close()
          }, 2000 - diffTime, this)
        } else {
          this.loading = false
          this.$emit('onRemovedCarReserve', response)
          this.close()
        }
      })
    },
    openForCar (carCode, sourceId, removeReserve) {
      this.reset()
      this.carCode = carCode
      this.sourceId = sourceId
      this.removeReserve = removeReserve

      window.$('#modal_reserve_car').modal()
    },
    close () {
      window.$('#modal_reserve_car').modal('hide')
    },
    reset () {
      this.carCode = null
      this.sourceId = null
      this.removeReserve = false
      this.loading = false
    }
  }
}
</script>
<template>
  <div>
    <div class="modal fase" role="dialog" id="modal_reserve_car">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 v-if="!removeReserve">Confirmar reserva de vehículo</h4>
            <h4 v-if="removeReserve">Confirmar quitar reserva de vehículo</h4>
          </div>

          <div class="modal-body">
            <div class="center_query" v-if="!removeReserve">
              ¿Estas seguro de querer marcar este vehículo como reservado?
            </div>
            <div class="center_query" v-if="removeReserve">
              ¿Quieres quitar la reserva de este vehículo?
            </div>
          </div>

          <div class="modal-footer">

            <button type="button" class="btn btn-info" v-bind:class="{disabled: loading}" v-on:click="onPressBtnReserveConfirm" v-if="!removeReserve">
              <span v-if="!loading">Reservar</span>
              <i class="fa fa-refresh fa-spin" v-if="loading"></i>
            </button>

            <button type="button" class="btn btn-info" v-bind:class="{disabled: loading}" v-on:click="onPressBtnRemoveReserveConfirm" v-if="removeReserve">
              <span v-if="!loading">Quitar reserva</span>
              <i class="fa fa-refresh fa-spin" v-if="loading"></i>
            </button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/ReserveCarComponent.vue